module.exports = __webpack_public_path__ + "static/media/oldVersion.1aa8eaf9.png";